import { render } from "./DeleteButton.vue?vue&type=template&id=12685a6d"
import script from "./DeleteButton.vue?vue&type=script&lang=js"
export * from "./DeleteButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DeleteButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12685a6d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12685a6d', __exports__)) {
    api.reload('12685a6d', __exports__)
  }
  
  module.hot.accept("./DeleteButton.vue?vue&type=template&id=12685a6d", () => {
    api.rerender('12685a6d', render)
  })

}


export default __exports__